import { render, staticRenderFns } from "./search-tool.vue?vue&type=template&id=fa237fac&scoped=true"
import script from "./search-tool.vue?vue&type=script&lang=js"
export * from "./search-tool.vue?vue&type=script&lang=js"
import style0 from "./search-tool.vue?vue&type=style&index=0&id=fa237fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa237fac",
  null
  
)

export default component.exports